export enum CommunitiesEnvironments {
  LOCAL = 'DEV',
  DEV = 'US_DEV',
  UAT = 'US_UAT',
  BR_PROD = 'PROD',
  US_PROD = 'US_PROD',
}
